import styled from 'styled-components';
import MuiLinkIcon from '@material-ui/icons/Link';

// TODO: Review design - we could show the link icon on hover and copy on click
// Not showing it for now.
export const LinkIcon = styled(MuiLinkIcon)`
  display: none;
`;
